// Payments.tsx
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTransactionsSupabaseStore } from "@/store/api/transactionsSupabaseStore";
import { PaymentsMainPanel } from "@/components/payments/PaymentsMainPanel";
import { PaymentsDialogs } from "@/components/payments/PaymentsDialogs";
import { TransactionData } from "@/types/types";
import { useSettingsStore } from "@/store/api/settingsStore";
import { useIsMobile } from "@/hooks/use-mobile";
import { useDraftResumeToast } from "@/hooks/useDraftResumeToast";

const Payments = () => {
  const { t } = useTranslation("payments");
  const [isPaymentDialogOpen, setIsPaymentDialogOpen] = useState(false);

  // Saisie de paiement interrompue par un reload → proposer de la reprendre.
  useDraftResumeToast([
    {
      formId: "payment-form",
      message: t("draft.paymentUnsaved", { ns: "bookingui" }),
      description: (d) => (d.amount ? `Montant : ${d.amount}` : undefined),
      isEmpty: (d) => !(d.client || d.amount || d.description),
      onResume: () => setIsPaymentDialogOpen(true),
    },
  ]);
  const [isSplitPaymentDialogOpen, setIsSplitPaymentDialogOpen] = useState(false);
  const [isInvoicePreviewOpen, setIsInvoicePreviewOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState<TransactionData | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const { fetchTransactions, isLoading } = useTransactionsSupabaseStore();
  const { fetchSettings } = useSettingsStore();
  const isMobile = useIsMobile();

  useEffect(() => {
    fetchTransactions();
    fetchSettings(); // devise/format
  }, [fetchTransactions, fetchSettings, isPaymentDialogOpen, isSplitPaymentDialogOpen]);

  return (
    <div className="min-h-screen flex flex-col">
      <main className={`flex-1 ${isMobile ? "p-2 pt-1" : "p-4 md:p-6"} max-w-7xl mx-auto w-full animate-fade-in`}>
        <PaymentsMainPanel
          onOpenPaymentDialog={() => setIsPaymentDialogOpen(true)}
          onOpenSplitPaymentDialog={() => setIsSplitPaymentDialogOpen(true)}
          setSelectedTransaction={setSelectedTransaction}
          setIsInvoicePreviewOpen={setIsInvoicePreviewOpen}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          isLoading={isLoading}
        />

        <PaymentsDialogs
          isPaymentDialogOpen={isPaymentDialogOpen}
          setIsPaymentDialogOpen={setIsPaymentDialogOpen}
          isSplitPaymentDialogOpen={isSplitPaymentDialogOpen}
          setIsSplitPaymentDialogOpen={setIsSplitPaymentDialogOpen}
          isInvoicePreviewOpen={isInvoicePreviewOpen}
          setIsInvoicePreviewOpen={setIsInvoicePreviewOpen}
          selectedTransaction={selectedTransaction}
          setSelectedTransaction={setSelectedTransaction}
          onSplitPaymentComplete={() => {
            // rechargement après paramétrage échéancier
            fetchTransactions();
          }}
        />
      </main>
    </div>
  );
};

export default Payments;
